/**
 * Created by hernanherreros on 2019-04-30
 */

import React from 'react'
import { BrowserRouter, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom'
import NotFoundRedirect from './utils/NotFoundRedirect'
import CongressProvider from '../providers/Congress/CongressProvider'
import LoadingScreen from '../components/Layout/LoadingScreen'
import Activation from '../containers/Activation'
import Wizard from '../containers/Wizard/Wizard'
import Layout from '../components/Layout/Layout'
import Confirm from '../containers/access/Confirm'
import MobileLinkSharing from '../containers/Sharing/MobileLinkSharing'
import ReactGA from 'react-ga'
import Update from '../containers/Update'
import FeedbackForm from '../containers/Feedback/FeedbackForm'

if (process.env.NODE_ENV !== 'development') {
  ReactGA.initialize('UA-143685474-1')
  ReactGA.pageview(window.location.pathname + window.location.search)
}

export default class RootRouter extends React.Component {
  render () {
    return (
      <BrowserRouter basename="/forms">
        <RouterListener/>
        <Switch>
          <Route path="/:congressSlug/sharing" component={SharingRoute}/>
          <Route path="/:congressSlug" component={Routes}/>
          <Route component={NotFoundRedirect}/>
        </Switch>
      </BrowserRouter>
    )
  }
}

const RouterListener = withRouter(({ history }: RouteComponentProps) => {
  history.listen((location, action) => {
    if (process.env.NODE_ENV !== 'development') {
      ReactGA.set({page: window.location.pathname + window.location.search})
      ReactGA.pageview(window.location.pathname + window.location.search)
    }
    window.scrollTo(0, 0)
  })

  return null
})

const Routes = () => (
    <CongressProvider loadingScreen={<LoadingScreen/>}>
      <Layout>

        <Route exact path="/:congressSlug" component={Activation}/>

        <Route exact path="/:congressSlug/access/:token/confirm" component={Confirm}/>

        <Route exact path="/:congressSlug/feedback/:uuid" component={FeedbackForm}/>
        <Route exact path="/:congressSlug/feedback" component={FeedbackForm}/>

        <Route path="/:congressSlug/update/:token" component={Update}/>

        <Route path="/:congressSlug/wizard/:token/:step" component={Wizard}/>
      </Layout>
    </CongressProvider>
)

const SharingRoute = () => (
  <CongressProvider loadingScreen={<LoadingScreen/>}>
    <Route exact path="/:congressSlug/sharing" component={MobileLinkSharing}/>
  </CongressProvider>
)
